<script>
import AdminLayout from '@layouts/admin-main'
import FinanceNav from '@components/admin/finance-nav'
import FinanceDividendList from '@components/admin/finance-dividend-list'

export default {
  page: {
    title: 'Admin::FinanceDividendList',
    meta: [{ name: 'description', content: 'Admin::FinanceDividendList' }],
  },
  components: {
    AdminLayout,
    FinanceNav,
    FinanceDividendList,
  },
}
</script>

<template>
  <AdminLayout>
    <FinanceNav></FinanceNav>
    <FinanceDividendList></FinanceDividendList>
  </AdminLayout>
</template>
